import { render, staticRenderFns } from "./QuestionPreviewVideo.vue?vue&type=template&id=561e6f04"
import script from "./QuestionPreviewVideo.vue?vue&type=script&lang=js"
export * from "./QuestionPreviewVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561e6f04')) {
      api.createRecord('561e6f04', component.options)
    } else {
      api.reload('561e6f04', component.options)
    }
    module.hot.accept("./QuestionPreviewVideo.vue?vue&type=template&id=561e6f04", function () {
      api.rerender('561e6f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/View/QuestionPreviewVideo.vue"
export default component.exports